import EmpListContext from 'app/contexts/EmployeeListContext'
import { useContext } from 'react'

const useEmpList = () => useContext(EmpListContext)

export default useEmpList
